const LEGACY_SESSION_KEY = "fd_crawler_cognito_session";
const LEGACY_PKCE_KEY = "fd_crawler_cognito_pkce";

interface AuthConfig {
  domain: string;
  clientId: string;
  logoutRedirectUri: string;
}

let configPromise: Promise<AuthConfig> | undefined;

function authConfig(): Promise<AuthConfig> {
  configPromise ??= fetch("/api/auth/config", { credentials: "same-origin" }).then(
    async (response) => {
      if (!response.ok) throw new Error("Sign-in configuration is unavailable");
      return response.json<AuthConfig>();
    },
  );
  return configPromise;
}

function clearLegacyBrowserTokens(): void {
  sessionStorage.removeItem(LEGACY_SESSION_KEY);
  sessionStorage.removeItem(LEGACY_PKCE_KEY);
}

export async function login(returnTo = "/", loginHint?: string): Promise<void> {
  clearLegacyBrowserTokens();
  const query = new URLSearchParams({ return_to: returnTo });
  if (loginHint) query.set("login_hint", loginHint);
  location.assign(`/auth/login?${query}`);
}

export async function logout(): Promise<void> {
  const response = await fetch("/auth/logout", {
    method: "POST",
    credentials: "same-origin",
  });
  if (!response.ok) throw new Error("Sign-out is unavailable");
  clearLegacyBrowserTokens();
  try {
    const config = await authConfig();
    const query = new URLSearchParams({
      client_id: config.clientId,
      logout_uri: config.logoutRedirectUri,
    });
    location.assign(`${config.domain}/logout?${query}`);
  } catch {
    location.assign("/");
  }
}
